import React, { Fragment, useState, useEffect } from "react";
import PageTitle from "../container/layouts/PageTitle";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Button,
  Modal,
  Form
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import axios from "axios";
import { Progress } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getInstance } from '../config/token';
import Spinner from 'react-bootstrap/Spinner'
import BootstrapTable from "react-bootstrap-table-next";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone
} from 'react-bootstrap-table2-paginator';
import 'react-phone-number-input/style.css'
import countryNames from 'react-phone-number-input/locale/en.json'
import AddContactPopup from './addContactPopup'
import AddSmsPopup from "../Sms/addSmsPopup";
import { isSupportedCountry } from "libphonenumber-js/core";

const prefix = process.env.REACT_APP_API_URL

const defaultPageSize = 100
const defaultSortOrder = 'asc'
const defaultSortKey = 'contact_name'

const sizePerPageList = [ {
  text: '10', value: 10
}, {
  text: '25', value: 25
}, {
  text: '50', value: 50
}, {
  text: '75', value: 75
}, {
  text: '100', value: 100
} ]

/// imge

const ContactList = () => {
  const [ show, setShow ] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(false);
  const[status, setStatus] = useState("")
  const[statusFilter, setStatusFilter] = useState("0")
  const [loadingList, setLoadingList] = useState(false);
  const[searchTicketSms, setSearchTicketSms] = useState("")
  const[columneDisplayField, setColumneDisplayField] = useState("")
  const[columneDisplayValue, setColumneDisplayValue] = useState(false)
  const[currentPage, setCurrentPage] = useState(1)
  const[pageSize, setPageSize] = useState(defaultPageSize)
  const[totalCount, setTotalCount]=useState(0)
  const[sortKey, setSortKey] = useState(defaultSortKey)
  const[sortType, setSortType]=useState(defaultSortOrder)
  const[randomValue, setRandomValue] = useState(0)
  const[selected, setSelected] = useState([])
  const[modalStatus, setModalStatus] = useState(false)
  const[statusSmsThreadId, setStatusSmsThreadId] = useState("")
  const [contactPopupShow, setContactPopupShow] = useState(false)
  const [contactId, setContactId] = useState(null)
  const [country, setCountry] = useState("")
  const [code, setCode] = useState("")
  const [phone, setPhone] = useState("")
  const [showSmsPopup, setShowSmsPopup] = useState(false)


  useEffect( () => {
    getContactList()
    
 }, [searchTicketSms, currentPage, pageSize, sortType, sortKey]);

//  useEffect( () => {
//   getTicketCount()
// }, []);

const columns = [
  {
    dataField: "id",
    text: "#",
    modify : false,
    sort: true,
  },
  {
    dataField: "phone",
    text: "Phone",
    hidden : localStorage.getItem("phone") == null || localStorage.getItem("phone") == 'null' ? false : JSON.parse(localStorage.getItem("phone")),
    modify : true,
    // sort: true
  },
  {
    dataField: "contact_name",
    text: "Name",
    hidden : localStorage.getItem("contact_name") == null || localStorage.getItem("contact_name") == 'null' ? false : JSON.parse(localStorage.getItem("contact_name")),
    modify : true,
    sort : true,
  },
  {
    dataField: "address_line_1",
    text: "Address1",
    hidden : localStorage.getItem("address_line_1") == null || localStorage.getItem("address_line_1") == 'null' ? true : JSON.parse(localStorage.getItem("address_line_1")),
    modify : true,
  },
  {
    dataField: "address_line_2",
    text: "Address2",
    hidden : localStorage.getItem("address_line_2") == null || localStorage.getItem("address_line_2") == 'null' ? true : JSON.parse(localStorage.getItem("address_line_2")),
    modify : true,
  },
  {
    dataField: "country",
    text: "Country",
    hidden : localStorage.getItem("country") == null || localStorage.getItem("country") == 'null' ? true : JSON.parse(localStorage.getItem("country")),
    modify : true,
  },
  {
    dataField: "city",
    text: "City",
    hidden : localStorage.getItem("city") == null || localStorage.getItem("city") == 'null' ? true : JSON.parse(localStorage.getItem("city")),
    modify : true,
  },
  {
    dataField: "state",
    text: "State",
    hidden : localStorage.getItem("state") == null || localStorage.getItem("state") == 'null' ? true : JSON.parse(localStorage.getItem("state")),
    modify : true,
  },
  {
    dataField: "zip",
    text: "Zip",
    hidden : localStorage.getItem("zip") == null || localStorage.getItem("zip") == 'null' ? true : JSON.parse(localStorage.getItem("zip")),
    modify : true,
  },
  {
    dataField: "contact_created_at",
    text: "Date",
    hidden : localStorage.getItem("contact_created_at") == null || localStorage.getItem("contact_created_at") == 'null' ? true : JSON.parse(localStorage.getItem("contact_created_at")),
    modify : true,
    sort : true
  },
]

// const mapticketSmsData = () => {
  var ticketSmsData = []
 contactList.map(function (item, i) {
    return (
      ticketSmsData.push({
        id :<div style={{cursor : "pointer"}} >
                <span style={{ display : "block"}} onClick={()=>openContactPopup(item.id)}><strong>{"BGCTC" + item.id}</strong></span>
                <Button
            as="a"
            // className="add-menu-sidebar"
            style={{ width:"max-content", display : "block",marginTop: "10px", backgroundColor:"#3D455A ", borderColor:"#3D455A" }}
            data-toggle="modal"
            data-target="#addOrderModalside"
            onClick={() => openSmsModal(item)}
          >
            + New SMS
          </Button>

            </div>,
        //   <div>
        // <Badge variant="success light" style = {{cursor : "pointer"}} className={item.status == 0 ?"status-open" : item.status == 1 ? "status-closed" : "status-pending"}>
        //   {item.status == 0
        //     ? 
        //     <span onClick={() => openStatusModal(item.id, 0)}>
        //         Pending
        //       </span>
        //     : item.status == 1? 
        //     <span onClick={() => openStatusModal(item.id, 1)}>
        //       Completed
        //     </span>
        //     : ""
        //   }
        // </Badge>
        // </div>
        // </div>,
        phone : item.phone ? item.phone : "-",
        contact_name : item.first_name && item.last_name ? item.first_name +" "+ item.last_name : item.first_name ? item.first_name : item.last_name ? item.last_name : "-",
        address_line_1 : item.address_line_1 ? item.address_line_1 : "-",
        address_line_2 : item.address_line_2 ? item.address_line_2 : "-",
        city : item.city ? item.city : "-",
        state : item.state ? item.state : "-",
        zip : item.zip ? item.zip : "-",
        country : item.country_code ? countryNames[item.country_code] : "-",
          contact_created_at : item.createdAt ? item.createdAt : "-",
      // id : item.id,
      // is_new_reply : item.is_new_reply
      })
    ) 
  })

  const openSmsModal = (contact) => {
    console.log(contact)
    if(contact && contact.phone) {
    
    setPhone(contact.phone)
    setCountry(contact.country_code)
    setCode(contact.calling_code)
    setShowSmsPopup(true)
    } else {
      toast.error("Phone is required!.", {
        position: "top-right",
    });
    }
  }

  const closeSmsPopup = () => {
    setPhone('')
    setCountry('')
    setCode('')
    setShowSmsPopup(false)
  }

const returnList = () => {
    return columns.map((column) => (
      column.modify?
      <Form.Check
        type="checkbox"
        key={column.dataField}
        inline
        label={column.text}
        id={column.dataField}
        //aria-pressed={(column.toggle) ? "true" : "false"}
        checked={column.hidden}
        aria-checked={column.hidden ? "true" : "false"}
        // onChange = {() => onColumnToggle(column.dataField)}
        onClick={() => showHideColumn(column.dataField, column.hidden)}
        // onClick={() => onColumnToggle(column.dataField)}
      /> : ""
    ));
};

const showHideColumn = (field,value) =>{
  if(field != 'id'){
    let fieldValue = (JSON.parse(localStorage.getItem(field)) == null || JSON.parse(localStorage.getItem(field)) == 'null' ? value : JSON.parse(localStorage.getItem(field)))
    localStorage.setItem(field, !fieldValue)
    setColumneDisplayValue(!columneDisplayValue)
    setColumneDisplayField(field)
    setRandomValue(Math.floor(Math.random() * 1000)+1)
  }
}

 const getContactList = () => {
   setLoadingList(true)
   let reqObj = {
    //  status : statusFilter,
     search : searchTicketSms,
     page : currentPage,
     size : pageSize,
     sort : sortType,
     key : sortKey,
    //  user : userTypeFilter
   }
   let config = getInstance('POST', `/api/get_contact_list`, reqObj);
  axios(config)
  .then((res) => {
    setTotalCount(res.data.count ? res.data.count : 0)
    setContactList(res.data.rows ? res.data.rows : [])
    setLoadingList(false)
  })
  .catch((err) => {
    setLoadingList(false)
  })
 }

const setSearchKey = (e) => {
  setSearchTicketSms(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const rowClasses = (row, rowIndex) => {
    if(row && row.is_new_reply ){
      return 'ticket-highlight';
    } else {
      return ''
    }
};

const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
  if(type == 'pagination'){
    if(sizePerPage != pageSize){
      setPageSize(sizePerPage)
      setCurrentPage(1)
    } else {
      setCurrentPage(page)
    }
    setSelected([])
  } else if(type == 'sort'){
    setSortType(sortOrder)
    setSortKey(sortField)
    setPageSize(defaultPageSize)
    setCurrentPage(1)
    setSelected([])
  }
}

const selectRow = {
  mode: 'checkbox',
  // clickToSelect: localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? true : false,
  hideSelectColumn: localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? false : true,
  selected: selected,
  onSelect: (row, isSelect, rowIndex, e) => {
    if (isSelect) {
      setSelected([...selected, row.id])
    } else {
      setSelected(selected.filter(x => x !== row.id))
    }
  },
  onSelectAll: (isSelect, rows, e) => {
    const ids = rows.map(r => r.id);
    if (isSelect) {
      setSelected(ids)
    } else {
      setSelected([])
    }
  }
};

const openContactPopup = (id) => {
  if(id){
    setContactId(id)
  }
  setContactPopupShow(true)
}

const closeContactPopup = () => {
  setContactPopupShow(false)
  setContactId(null)
}
  return (
    <Fragment>
      {/* <PageTitle activeMenu="Table" motherMenu="Bootstrap" /> */}
      {/* <div className="deznav"> */}
      <PerfectScrollbar className="deznav-scroll">
        <div style={{ display: "inline" }}>
          {/* <select
            className="form-control form-border-color"
            style={{
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            name="filter"
            id="filter"
            defaultValue={statusFilter}
            onChange={(e) => changeStatusFilter(e)}
          >
            <option value="4">All Status</option>
            <option value="0">Pending</option>
            <option value="1">Completed</option>
          </select> */}
          {/* <React.Fragment>
          {localStorage.getItem("userType") == 1 ||
          localStorage.getItem("userType") == 2 ?       
          <select
            className="form-control form-border-color"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            name="user_filter"
            id="user_filter"
            defaultValue={userTypeFilter}
            onChange={(e) => changeUserFilter(e)}
          >
            <option value="0">All User</option>
            <option value="1">Admin</option>
            <option value="2">Employee</option>
            <option value="3">Customer</option>
            <option value="4">Provider</option>
          </select> : ""}
          </React.Fragment>   */}

          <input
            type="text"
            name="title"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            className="form-control form-border-color"
            maxLength={255}
            placeholder="Search Here..."
            value={searchTicketSms}
            onChange={(e) => setSearchKey(e)}
          />
          {/* <span class="badge badge-sm light badge-primary status-count-span status-open">
            Open : {openCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-pending">
            Pending : {pendingCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-closed">
          Completed : {closedCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-spam">
          Spam : {spamCount}
          </span> */}

          <Button
            as="a"
            // className="add-menu-sidebar"
            style={{ float: "right", marginBottom: "1rem" }}
            data-toggle="modal"
            data-target="#addOrderModalside"
            onClick={() => openContactPopup(null)}
          >
            + New Contact
          </Button>
        </div>

        {
          contactPopupShow ? 
          <AddContactPopup contactId = {contactId} closeContactPopup = {closeContactPopup} type="contact" userType = {0} getContactList={getContactList} contactPopupShow = {contactPopupShow} />
          :""
        }
         {
          showSmsPopup ? 
          <AddSmsPopup closeSmsPopup = {closeSmsPopup} type="contact" newEvent = {showSmsPopup} phone = {phone} country={country} code={code} />
          :""
        }

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </PerfectScrollbar>
      {/* </div> */}
      <Row>
        <Col lg={12}>
          <Card className="form-border-color">
            <Card.Header style={{borderBottom : "0px", paddingBottom : "0.5rem"}}>
              <Card.Title>Contact List</Card.Title>
            </Card.Header>
            {/* <div className="ticket-type-count-div">
              {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? 
              <React.Fragment>
              <span class="badge badge-sm light badge-primary status-count-span rent-count">
                Rent : {rentCount}
              </span>
              <span class="badge badge-sm light badge-primary status-count-span support-count">
                Support : {supportCount}
              </span></React.Fragment> : ""}
              </div> */}
            <Card.Body style={{paddingBottom : "1.5rem"}}>
              <div>{columneDisplayValue}</div>
              {loadingList ? (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                </div>
              ) : contactList.length > 0 ? (
                    <div>
                      <Dropdown style={{display : "inline-block"}} show={show}>
                        <Dropdown.Toggle
                          onClick={() => setShow(!show)}
                          variant="success"
                          id="dropdown-basic"
                        >
                          Show/Hide
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-custom">
                          {returnList()}
                        </Dropdown.Menu>
                      </Dropdown>
                      <div style={{display : "inline-block", paddingLeft : "1rem"}}>
                    {/* {(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) && selected.length > 0 ?
                        <select
                      className="form-control form-border-color"
                      style={{
                        height : "auto"
                      }}
                      name="type"
                      id="type"
                      defaultValue={""}
                      onChange={(e) => changeStatus(e, selected)}
                    >
                      <option value="" disabled>Change Status</option>
                      <option disabled = {statusFilter == 0 ? true : null} value="0">Pending</option>
                      <option disabled = {statusFilter == 1 ? true : null} value="1">Completed</option>
                    </select>
                  :""} */}
                  </div>
                      <hr />
                      <BootstrapTable
                      remote
                        className="table-responsive"
                        keyField="id"
                        data={ticketSmsData}
                        columns={columns}
                        pagination={ paginationFactory({ page : currentPage, sizePerPage : pageSize, totalSize:totalCount, paginationSize : 3, sizePerPageList : sizePerPageList }) }
                        rowClasses={ rowClasses }
                        onTableChange={ handleTableChange }
                        // selectRow={ selectRow }
                      />
                    </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ fontWeight: "700" }}>{"🎉 No Contacts."}</span>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default ContactList;
